/* eslint-disable no-restricted-imports -- This file is the designated entry point for sentry imports */
import { wrapSentryForProject, mapEnvironmentToDSN } from '@grantstreet/sentry-multiplex'
import { isProd } from '@grantstreet/psc-environment'

const dsns = {
  // TODO: Rename to e-wallet-vue
  // e-wallet-ui-prod and -nonprod projects.
  prod: 'https://ded410a97a884358bf82242a9ee20565@o168195.ingest.sentry.io/1242931',
  nonprod: 'https://014231ea63c54e45bcc80889e7a75913@o168195.ingest.sentry.io/5827659',
}

const Sentry = wrapSentryForProject('e-wallet-vue', {
  dsn: () => mapEnvironmentToDSN(dsns, isProd),
  allowUrls: [/e-wallet\.grantstreet\.com\/.*\.js/],
})
export default Sentry
export const sentryException = Sentry.captureException
export { sentryCodes } from '@grantstreet/sentry-multiplex'
